import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from 'drift-ui';
import { useTranslation } from 'react-i18next';
import { DriftIcons } from 'drift-ui';
const { CloseIcon } = DriftIcons;

interface RemoveOwnerConfirmationProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const RemoveOwnerConfirmationModal: FC<RemoveOwnerConfirmationProps> = ({ open, onCancel, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      aria-labelledby={t('digital_onboarding.banking.owner_info.remove_alert_title')}
      aria-describedby={t('digital_onboarding.banking.owner_info.remove_alert_message')}
    >
      <DialogTitle id="close-application-title">
        {t('digital_onboarding.banking.owner_info.remove_alert_title')}
      </DialogTitle>
      <IconButton
        aria-label={t('Cancel')}
        onClick={onCancel}
        sx={{
          position: 'absolute',
          right: 24,
          top: 18,
          color: (theme) => theme.palette.gray[700],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ minWidth: '552px' }}>
        <DialogContentText>{t(`digital_onboarding.banking.owner_info.remove_alert_message`)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          {t('Cancel')}
        </Button>
        <Button variant="contained" onClick={onConfirm} autoFocus>
          {t('Remove')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
